export interface OnlineRowContext {
  login: number;
  dataSourceId: number;
  dataSourceName: string;
}

// The read-only Login / Data Source header shared by all three modals.
export function ContextHeader({ ctx }: { ctx: OnlineRowContext }) {
  return (
    <div className="mb-3">
      <div className="d-flex">
        <div className="fw-semibold me-2" style={{ width: 110 }}>Login:</div>
        <div>{ctx.login}</div>
      </div>
      <div className="d-flex">
        <div className="fw-semibold me-2" style={{ width: 110 }}>Data Source:</div>
        <div>{ctx.dataSourceName}</div>
      </div>
    </div>
  );
}
